
import '../styles/basketItemDiscount.css';
import '../styles/summary.css';


export default function ModalContentSection(props) {
    return (
        <div className='section'>
            {props.section.title && <h4 className='title'>{props.section.title}</h4>}
            <h4>{props.section.subTitle}</h4>
            <p>{props.section.description}</p>
        </div>
    )
}
